import { defineComponent as _defineComponent } from 'vue';
import { SImageLazy } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
import { useMainSiteLink } from '@/shared/composables';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup: function setup(__props) {
    defineComponent({
      name: 'AppFooter'
    });
    var currentYear = new Date().getFullYear();
    var mainSiteLink = useMainSiteLink();
    return {
      __sfc: true,
      currentYear: currentYear,
      mainSiteLink: mainSiteLink,
      SImageLazy: SImageLazy
    };
  }
});